import React from 'react';
import EmoticonCryOutlineIcon from 'mdi-react/EmoticonCryOutlineIcon';

import { EmptyState } from '@crm-framework/empty-state';

import { BaseLayout } from '@crm-package/layouts';

import { Page } from './styles';

export const Unavailable: React.FC = () => (
  <Page>
    <BaseLayout>
      <EmptyState
        icon={EmoticonCryOutlineIcon}
        header="Oops! App is unavailable now"
        description="Please contact your administrator or try to refresh this page later"
      />
    </BaseLayout>
  </Page>
);
